var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIco16Hide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    stroke: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M7.333.767C3.283.767 0 4.777 0 5.512c0 .734 3.283 4.745 7.333 4.745 4.05 0 7.334-4.011 7.334-4.745S11.383.767 7.333.767z",
    transform: "translate(-376 -175) translate(376 175) translate(.667 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.922 5.512c0 1.429-1.16 2.588-2.589 2.588S4.745 6.94 4.745 5.512c0-1.43 1.16-2.588 2.588-2.588 1.43 0 2.589 1.159 2.589 2.588z",
    transform: "translate(-376 -175) translate(376 175) translate(.667 2.5)"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M2 11.314L13.314 0",
    transform: "translate(-376 -175) translate(376 175) translate(.667 2.5) matrix(-1 0 0 1 15.314 0)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIco16Hide);
export default __webpack_public_path__ + "static/media/ico16Hide.3326840b.svg";
export { ForwardRef as ReactComponent };